// environmentalEngineeringData.js

const environmentalEngineeringData = [
    {
      section: "Mathematics & Natural Sciences",
      subtotal: "39",
      courses: [
        { id: "MATH32", code: "MATH 32", title: "Calculus I", credit: 4 },
        { id: "MATH34", code: "MATH 34", title: "Calculus II", credit: 4 },
        { id: "MATH42", code: "MATH 42", title: "Calculus III", credit: 4 },
        { id: "MATH51", code: "MATH 51", title: "Differential Equations", credit: 4 },
        { id: "CHEM1", code: "CHEM 1", title: "Gen. Chem. I w/ lab", credit: 5 },
        { id: "CHEM2", code: "CHEM 2", title: "Gen. Chem. II w/ lab", credit: 5 },
        { id: "PHY11", code: "PHY 11", title: "Gen. Physics I w/ lab", credit: 5 },
        { id: "EC_Sci_Elec_a", code: "Earth & Climate Sci. Elective (a)", title: "", credit: 3 },
        { id: "BIO13", code: "BIO 13", title: "Cells & Organisms", credit: 3 },
        { id: "BIO15", code: "BIO 15", title: "Cells & Organisms Lab", credit: 2 },
      ],
    },
    {
      section: "Stewardship",
      subtotal: "9",
      courses: [
        { id: "CEE32", code: "CEE 32", title: "Eng. Sustain. & Resil. Soc.", credit: 3 },
        { id: "CEE52", code: "CEE 52", title: "Public Health Engineering", credit: 3 },
        { id: "CEE84", code: "CEE 84", title: "Resil. & Equitable Infrast.", credit: 3 },
      ],
    },
    {
      section: "Communication",
      subtotal: "13",
      courses: [
        { id: "ENG1", code: "ENG 1", title: "Expos. Writing or ENG 3", credit: 3 },
        { id: "EM51", code: "EM 51", title: "Engineering Management", credit: 3 },
        { id: "EM52", code: "EM 52", title: "Tech. & Mang. Commun.", credit: 3 },
        { id: "CEE187_ES18", code: "CEE 187 or ES 18", title: "GIS or CAD", credit: "3-4" },
      ],
    },
    {
      section: "HASS",
      subtotal: "9",
      courses: [
        { id: "Humanities_Elec_b", code: "Humanities Elective (b)", title: "", credit: "≥3" },
        { id: "Social_Science_Elec_c", code: "Social Science Elective (c)", title: "", credit: "≥3" },
      ],
    },
    {
      section: "Processes",
      subtotal: "18",
      courses: [
        { id: "ES7", code: "ES 7", title: "Thermodynamics", credit: 3 },
        { id: "ES8", code: "ES 8", title: "Fluid Mechanics", credit: 3 },
        { id: "CEE12", code: "CEE 12", title: "Hydraulics", credit: 4 },
        { id: "CEE34", code: "CEE 34", title: "Poll. Fate & Transport", credit: 4 },
        { id: "CEE36", code: "CEE 36", title: "Environ. Processes", credit: 4 },
      ],
    },
    {
      section: "Analysis",
      subtotal: "17",
      courses: [
        { id: "ES2_CS11", code: "ES 2 or CS 11", title: "Intro. Comp. in Eng. or Intro. Comp. Sci.", credit: 4 },
        { id: "ES55", code: "ES 55", title: "Numerical Methods", credit: 3 },
        { id: "ES56_CEE156", code: "ES 56 or CEE 156", title: "Prob. & Stats. or Biostatistics", credit: 4 },
        { id: "CEE86", code: "CEE 86", title: "Integ. Plan. & Mgt.", credit: 3 },
        { id: "CEE132_CEE152", code: "CEE 132 or CEE 152", title: "Data Sci. Sustainability or Env. Health Data", credit: 3 },
      ],
    },
    {
      section: "Design",
      subtotal: "13",
      courses: [
        { id: "EN1_Design", code: "EN 1", title: "Applications in Eng.", credit: 3 },
        { id: "Design_Elec_e1", code: "Design Elective (e)", title: "", credit: 3 },
        { id: "Design_Elec_e2", code: "Design Elective (e)", title: "", credit: 3 },
        { id: "CEE88", code: "CEE 88", title: "Capstone Design", credit: 4 },
      ],
    },
    {
      section: "Technical Elective",
      subtotal: "9",
      courses: [
        {
          id: "Tech_Electives",
          code: "Technical Electives",
          title:
            "≥9 SHU Technical Electives (see note f) are required for the degree. List courses below.",
          credit: "",
        },
      ],
    },
  ];
  
  export default environmentalEngineeringData;
  